import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const Loading = () => <CircularProgress className="loading-styles" />;
export default Loading;
